import { useTranslation } from 'react-i18next';
import { ModulePlaceholderForm } from '../../components/ModulePlaceholderForm';

export default function NewReview() {
  const { t } = useTranslation('panel');
  return (
    <ModulePlaceholderForm
      title="New performance review"
      listPath="/panel/performances"
      tabs={[
        {
          key: 'basic',
          label: t('form.tabs.basic'),
          fields: [
            { key: 'employeeId', label: 'Employee', required: true },
            { key: 'reviewerId', label: 'Reviewer (manager)', required: true },
            { key: 'cycle', label: 'Review cycle', type: 'select', required: true, options: [
              { value: 'q1', label: 'Q1' },
              { value: 'q2', label: 'Q2' },
              { value: 'q3', label: 'Q3' },
              { value: 'q4', label: 'Q4' },
              { value: 'annual', label: 'Annual' },
            ] },
            { key: 'period', label: 'Period (YYYY-MM)' },
          ],
        },
        {
          key: 'details',
          label: t('form.tabs.details'),
          fields: [
            { key: 'kpiScore', label: 'KPI score (0-100)', type: 'number' },
            { key: 'rating', label: 'Overall rating', type: 'select', options: [
              { value: '1', label: '1 — Needs improvement' },
              { value: '2', label: '2 — Below expectations' },
              { value: '3', label: '3 — Meets expectations' },
              { value: '4', label: '4 — Exceeds expectations' },
              { value: '5', label: '5 — Outstanding' },
            ] },
            { key: 'strengths', label: 'Strengths', type: 'textarea' },
            { key: 'improvements', label: 'Areas to improve', type: 'textarea' },
          ],
        },
        {
          key: 'documents',
          label: t('form.tabs.documents'),
          fields: [
            { key: 'goals', label: 'Goals for next cycle', type: 'textarea' },
            { key: 'reviewedAt', label: 'Reviewed on', type: 'date' },
          ],
        },
        { key: 'review', label: t('form.tabs.review'), fields: [] },
      ]}
    />
  );
}
